var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('i',{staticClass:"fa fa-check text-success"}),_vm._v(" Optioneel: voeg zelf extra vragen toe (€50 per vraag) ")])}]

export { render, staticRenderFns }